import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { CartProvider } from "@/lib/cart";
import LandingPage from "@/pages/LandingPage";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import Adatkezeles from "@/pages/Adatkezeles";
import CookieBanner from "@/components/CookieBanner";
import GtmLoader from "@/components/GtmLoader";

function App() {
  return (
    <div className="App">
      <CartProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/admin" element={<AdminLogin />} />
            <Route path="/admin/dashboard" element={<AdminDashboard />} />
            <Route path="/adatkezeles" element={<Adatkezeles />} />
          </Routes>
          <CookieBanner />
        </BrowserRouter>
        <Toaster
          theme="dark"
          position="bottom-right"
          toastOptions={{
            style: {
              background: "#0A0A0F",
              border: "1px solid rgba(139,92,246,0.3)",
              color: "#fff",
            },
          }}
        />
        <GtmLoader />
      </CartProvider>
    </div>
  );
}

export default App;
